import {MutableRefObject, useContext, useEffect} from 'react';
import {VisualContext} from '../context/modules/dimensions/VisualContext';
import {ResponseVehicle} from '../types/api';
import Konva from 'konva';

const useImagesMoveTop = (
  vehicles: ResponseVehicle[],
  firstImageRef: MutableRefObject<Konva.Image | null>,
  secondImageRef: MutableRefObject<Konva.Image | null>,
  thirdImageRef: MutableRefObject<Konva.Image | null>
) => {
  const visualCtx = useContext(VisualContext);

  useEffect(() => {
    let index = 0;

    if (visualCtx?.vehicle?.acode) {
      index = vehicles.findIndex(
        (vehicle) => vehicle.acode == visualCtx?.vehicle?.acode
      );
    }

    switch (index) {
      case 0:
        firstImageRef.current?.moveToTop();
        break;

      case 1:
        if (secondImageRef.current) secondImageRef.current.moveToTop();
        break;

      case 2:
        if (thirdImageRef.current) thirdImageRef.current.moveToTop();
        break;
    }
  }, [visualCtx?.vehicle]);
};

export default useImagesMoveTop;
